import { Link } from "react-router-dom";

const promos = [
  {
    badge: "First Visit",
    title: "New Client Welcome",
    desc: "Enjoy 20% off any service on your first appointment. Discover why Las Vegas trusts VegasGlamHair for European-quality results.",
    price: "20% OFF",
    expires: "Valid through June 2026",
    cta: "Claim Offer",
    icon: "ri-gift-line",
    highlight: true,
  },
  {
    badge: "Seasonal",
    title: "Spring Color Refresh",
    desc: "Book a full balayage or color service and receive a complimentary deep-conditioning Olaplex treatment — a $75 value.",
    price: "$75 Value",
    expires: "Valid through May 2026",
    cta: "Book Now",
    icon: "ri-leaf-line",
    highlight: false,
  },
  {
    badge: "Refer a Friend",
    title: "Refer & Reward",
    desc: "Bring a friend for their first visit and you both receive $30 off your next service. Share the glam.",
    price: "$30 Each",
    expires: "Ongoing",
    cta: "Learn More",
    icon: "ri-user-heart-line",
    highlight: false,
  },
  {
    badge: "VIP",
    title: "Glam Membership",
    desc: "Join our VIP Glam Club — monthly styling credits, priority booking, and exclusive member-only events in Las Vegas.",
    price: "From $99/mo",
    expires: "Limited spots",
    cta: "Join the Club",
    icon: "ri-vip-crown-line",
    highlight: false,
  },
];

export default function ExclusivePromotions() {
  return (
    <section className="w-full bg-white py-24 px-6" id="promotions">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">Exclusive Offers</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
            Promotions &amp; Specials
          </h2>
          <p className="text-neutral-500 mt-4 text-sm max-w-md mx-auto leading-relaxed">
            Premium experiences shouldn&apos;t have to wait. Take advantage of our curated client offers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {promos.map((promo) => (
            <div
              key={promo.title}
              className={`relative rounded-lg overflow-hidden flex flex-col p-8 border transition-all duration-300 hover:-translate-y-1 ${
                promo.highlight
                  ? "bg-[#1a1209] border-[#C9A96E] text-white"
                  : "bg-[#faf8f5] border-neutral-100 text-neutral-900"
              }`}
            >
              {promo.highlight && (
                <div className="absolute top-0 right-0 bg-[#C9A96E] text-white text-[10px] font-bold tracking-widest uppercase px-4 py-1.5">
                  Most Popular
                </div>
              )}
              <div className={`w-12 h-12 flex items-center justify-center rounded-full mb-5 ${promo.highlight ? "bg-[#C9A96E]/20" : "bg-[#C9A96E]/10"}`}>
                <i className={`${promo.icon} text-xl text-[#C9A96E]`}></i>
              </div>
              <span className={`text-xs font-bold tracking-widest uppercase mb-2 ${promo.highlight ? "text-[#C9A96E]" : "text-[#C9A96E]"}`}>
                {promo.badge}
              </span>
              <h3 className={`text-lg font-bold mb-3 leading-tight ${promo.highlight ? "text-white" : "text-neutral-900"}`} style={{ fontFamily: "'Playfair Display', serif" }}>
                {promo.title}
              </h3>
              <p className={`text-sm leading-relaxed mb-5 flex-1 ${promo.highlight ? "text-white/60" : "text-neutral-500"}`}>
                {promo.desc}
              </p>
              <div className={`text-2xl font-bold mb-1 ${promo.highlight ? "text-[#C9A96E]" : "text-neutral-900"}`} style={{ fontFamily: "'Playfair Display', serif" }}>
                {promo.price}
              </div>
              <p className={`text-xs mb-6 ${promo.highlight ? "text-white/40" : "text-neutral-400"}`}>{promo.expires}</p>
              <Link
                to="/booking"
                className={`text-sm font-semibold tracking-widest uppercase py-3 px-6 rounded-sm text-center transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  promo.highlight
                    ? "bg-[#C9A96E] text-white hover:bg-[#b8934f]"
                    : "border border-[#C9A96E] text-[#C9A96E] hover:bg-[#C9A96E] hover:text-white"
                }`}
              >
                {promo.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
